/* tslint:disable */
/* eslint-disable */
/**
 * OnData.Backup
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { Configuration } from './configuration';
import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from './base';

/**
 * 
 * @export
 * @interface AlertAndTime
 */
export interface AlertAndTime {
    /**
     * 
     * @type {string}
     * @memberof AlertAndTime
     */
    'alert'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AlertAndTime
     */
    'isWarning'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AlertAndTime
     */
    'alertTime'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof AlertAndTime
     */
    'databaseId'?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof AlertAndTime
     */
    'parameters'?: Array<string> | null;
}
/**
 * 
 * @export
 * @interface BackupDashboardResponseDto
 */
export interface BackupDashboardResponseDto {
    /**
     * 
     * @type {number}
     * @memberof BackupDashboardResponseDto
     */
    'backupSuccessCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof BackupDashboardResponseDto
     */
    'backupWarningCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof BackupDashboardResponseDto
     */
    'backupFailedCount'?: number;
    /**
     * 
     * @type {Array<AlertAndTime>}
     * @memberof BackupDashboardResponseDto
     */
    'backupAlerts'?: Array<AlertAndTime> | null;
    /**
     * 
     * @type {number}
     * @memberof BackupDashboardResponseDto
     */
    'validationSuccessCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof BackupDashboardResponseDto
     */
    'validationWarningCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof BackupDashboardResponseDto
     */
    'validationFailedCount'?: number;
    /**
     * 
     * @type {Array<AlertAndTime>}
     * @memberof BackupDashboardResponseDto
     */
    'validationAlerts'?: Array<AlertAndTime> | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export enum BackupJobStatus {
    NoBackup = 0,
    InProgress = 1,
    Failed = 2,
    Received = 3
}

/**
 * 
 * @export
 * @interface BackupResponseDto
 */
export interface BackupResponseDto {
    /**
     * 
     * @type {number}
     * @memberof BackupResponseDto
     */
    'organizationId'?: number;
    /**
     * 
     * @type {number}
     * @memberof BackupResponseDto
     */
    'databaseId'?: number;
    /**
     * 
     * @type {number}
     * @memberof BackupResponseDto
     */
    'backupId'?: number;
    /**
     * 
     * @type {number}
     * @memberof BackupResponseDto
     */
    'engineId'?: number;
    /**
     * 
     * @type {string}
     * @memberof BackupResponseDto
     */
    'engineVersion'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BackupResponseDto
     */
    'engineEdition'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BackupResponseDto
     */
    'buildVersion'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BackupResponseDto
     */
    'scriptFolder'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BackupResponseDto
     */
    'path'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof BackupResponseDto
     */
    'size'?: number;
    /**
     * 
     * @type {string}
     * @memberof BackupResponseDto
     */
    'sizeText'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BackupResponseDto
     */
    'createdTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof BackupResponseDto
     */
    'receivedTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BackupResponseDto
     */
    'validationStartTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BackupResponseDto
     */
    'validationEndTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BackupResponseDto
     */
    'restoreEndTime'?: string | null;
    /**
     * 
     * @type {BackupType}
     * @memberof BackupResponseDto
     */
    'backupType'?: BackupType;
    /**
     * 
     * @type {string}
     * @memberof BackupResponseDto
     */
    'backupTypeText'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BackupResponseDto
     */
    'backupLog'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BackupResponseDto
     */
    'backupException'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BackupResponseDto
     */
    'restoreLog'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BackupResponseDto
     */
    'restoreException'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BackupResponseDto
     */
    'validationLog'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BackupResponseDto
     */
    'validationException'?: string | null;
    /**
     * 
     * @type {BackupStatus}
     * @memberof BackupResponseDto
     */
    'status'?: BackupStatus;
    /**
     * 
     * @type {string}
     * @memberof BackupResponseDto
     */
    'statusText'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof BackupResponseDto
     */
    'isFileDeleted'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BackupResponseDto
     */
    'isEncrypted'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof BackupResponseDto
     */
    'snapshotId'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof BackupResponseDto
     */
    'isDeleted'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof BackupResponseDto
     */
    'latestFullBackupSize'?: number;
}
/**
 * 
 * @export
 * @interface BackupResponseDtoPaginationResult
 */
export interface BackupResponseDtoPaginationResult {
    /**
     * 
     * @type {Array<BackupResponseDto>}
     * @memberof BackupResponseDtoPaginationResult
     */
    'items'?: Array<BackupResponseDto> | null;
    /**
     * 
     * @type {number}
     * @memberof BackupResponseDtoPaginationResult
     */
    'total'?: number;
}
/**
 * 
 * @export
 * @interface BackupScheduleInput
 */
export interface BackupScheduleInput {
    /**
     * 
     * @type {number}
     * @memberof BackupScheduleInput
     */
    'databaseId'?: number;
    /**
     * 
     * @type {BackupType}
     * @memberof BackupScheduleInput
     */
    'backupType'?: BackupType;
    /**
     * 
     * @type {ValidationFrequency}
     * @memberof BackupScheduleInput
     */
    'frequency'?: ValidationFrequency;
    /**
     * 
     * @type {number}
     * @memberof BackupScheduleInput
     */
    'interval'?: number;
    /**
     * 
     * @type {number}
     * @memberof BackupScheduleInput
     */
    'startHour'?: number;
    /**
     * 
     * @type {number}
     * @memberof BackupScheduleInput
     */
    'startMinute'?: number;
    /**
     * 
     * @type {string}
     * @memberof BackupScheduleInput
     */
    'daysOfWeek'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof BackupScheduleInput
     */
    'dayOfMonth'?: number;
}
/**
 * 
 * @export
 * @interface BackupScheduleResponseDto
 */
export interface BackupScheduleResponseDto {
    /**
     * 
     * @type {number}
     * @memberof BackupScheduleResponseDto
     */
    'organizationId'?: number;
    /**
     * 
     * @type {number}
     * @memberof BackupScheduleResponseDto
     */
    'databaseId'?: number;
    /**
     * 
     * @type {BackupType}
     * @memberof BackupScheduleResponseDto
     */
    'backupType'?: BackupType;
    /**
     * 
     * @type {ValidationFrequency}
     * @memberof BackupScheduleResponseDto
     */
    'frequency'?: ValidationFrequency;
    /**
     * 
     * @type {number}
     * @memberof BackupScheduleResponseDto
     */
    'interval'?: number;
    /**
     * 
     * @type {number}
     * @memberof BackupScheduleResponseDto
     */
    'startHour'?: number;
    /**
     * 
     * @type {number}
     * @memberof BackupScheduleResponseDto
     */
    'startMinute'?: number;
    /**
     * 
     * @type {string}
     * @memberof BackupScheduleResponseDto
     */
    'daysOfWeek'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof BackupScheduleResponseDto
     */
    'dayOfMonth'?: number;
    /**
     * 
     * @type {string}
     * @memberof BackupScheduleResponseDto
     */
    'cronExpression'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BackupScheduleResponseDto
     */
    'timeZoneName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BackupScheduleResponseDto
     */
    'timeZoneOffset'?: string | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export enum BackupStatus {
    BackingUp = 0,
    BackupSuccess = 1,
    BackupFailed = 2,
    Validating = 3,
    RestoreFailed = 4,
    ValidationFailed = 5,
    ValidationSuccess = 6
}

/**
 * 
 * @export
 * @enum {string}
 */

export enum BackupType {
    Differential = 0,
    Full = 1,
    Log = 2,
    Incremental = 3
}

/**
 * 
 * @export
 * @interface BackupTypeResponseDto
 */
export interface BackupTypeResponseDto {
    /**
     * 
     * @type {BackupType}
     * @memberof BackupTypeResponseDto
     */
    'backupType'?: BackupType;
    /**
     * 
     * @type {string}
     * @memberof BackupTypeResponseDto
     */
    'text'?: string | null;
}
/**
 * 
 * @export
 * @interface CloneDatabaseInput
 */
export interface CloneDatabaseInput {
    /**
     * 
     * @type {string}
     * @memberof CloneDatabaseInput
     */
    'databaseName': string;
    /**
     * 
     * @type {number}
     * @memberof CloneDatabaseInput
     */
    'engineId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CloneDatabaseInput
     */
    'description'?: string | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export enum CloudProvider {
    Azure = 1,
    AzureUSGovernment = 2,
    Aws = 3,
    Gcp = 4
}

/**
 * 
 * @export
 * @interface CollectionInfoInput
 */
export interface CollectionInfoInput {
    /**
     * 
     * @type {string}
     * @memberof CollectionInfoInput
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CollectionInfoInput
     */
    'partitionKey'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CollectionInfoInput
     */
    'totalRows'?: number;
    /**
     * 
     * @type {string}
     * @memberof CollectionInfoInput
     */
    'jsonSchema'?: string | null;
}
/**
 * 
 * @export
 * @interface CreateBackupInput
 */
export interface CreateBackupInput {
    /**
     * 
     * @type {number}
     * @memberof CreateBackupInput
     */
    'databaseId'?: number;
    /**
     * 
     * @type {BackupType}
     * @memberof CreateBackupInput
     */
    'backupType': BackupType;
    /**
     * 
     * @type {DatabaseType}
     * @memberof CreateBackupInput
     */
    'databaseType': DatabaseType;
    /**
     * 
     * @type {string}
     * @memberof CreateBackupInput
     */
    'engineVersion': string;
    /**
     * 
     * @type {string}
     * @memberof CreateBackupInput
     */
    'edition'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateBackupInput
     */
    'buildVersion'?: string | null;
}
/**
 * 
 * @export
 * @interface CreateDatabaseInput
 */
export interface CreateDatabaseInput {
    /**
     * 
     * @type {string}
     * @memberof CreateDatabaseInput
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof CreateDatabaseInput
     */
    'engineId': number;
    /**
     * 
     * @type {string}
     * @memberof CreateDatabaseInput
     */
    'description'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CreateDatabaseInput
     */
    'encryptionKeyId': number;
}
/**
 * 
 * @export
 * @interface DatabaseResponseDto
 */
export interface DatabaseResponseDto {
    /**
     * 
     * @type {number}
     * @memberof DatabaseResponseDto
     */
    'organizationId'?: number;
    /**
     * 
     * @type {number}
     * @memberof DatabaseResponseDto
     */
    'databaseId'?: number;
    /**
     * 
     * @type {string}
     * @memberof DatabaseResponseDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DatabaseResponseDto
     */
    'description'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DatabaseResponseDto
     */
    'engineId'?: number;
    /**
     * 
     * @type {string}
     * @memberof DatabaseResponseDto
     */
    'engineVersion'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DatabaseResponseDto
     */
    'engineEdition'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DatabaseResponseDto
     */
    'retentionDaysId'?: number;
    /**
     * 
     * @type {number}
     * @memberof DatabaseResponseDto
     */
    'retentionDays'?: number;
    /**
     * 
     * @type {DatabaseType}
     * @memberof DatabaseResponseDto
     */
    'databaseType'?: DatabaseType;
    /**
     * 
     * @type {string}
     * @memberof DatabaseResponseDto
     */
    'createdTime'?: string;
    /**
     * 
     * @type {number}
     * @memberof DatabaseResponseDto
     */
    'size'?: number;
    /**
     * 
     * @type {string}
     * @memberof DatabaseResponseDto
     */
    'sizeText'?: string | null;
    /**
     * 
     * @type {ResultLevel}
     * @memberof DatabaseResponseDto
     */
    'backupResult'?: ResultLevel;
    /**
     * 
     * @type {number}
     * @memberof DatabaseResponseDto
     */
    'backupResultRefId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof DatabaseResponseDto
     */
    'backupAlert'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DatabaseResponseDto
     */
    'lastBackupTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DatabaseResponseDto
     */
    'backupFailedLog'?: string | null;
    /**
     * 
     * @type {ResultLevel}
     * @memberof DatabaseResponseDto
     */
    'validationResult'?: ResultLevel;
    /**
     * 
     * @type {number}
     * @memberof DatabaseResponseDto
     */
    'validationResultRefId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof DatabaseResponseDto
     */
    'validationAlert'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DatabaseResponseDto
     */
    'lastValidationTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DatabaseResponseDto
     */
    'validationFailedLog'?: string | null;
    /**
     * 
     * @type {BackupJobStatus}
     * @memberof DatabaseResponseDto
     */
    'backupJobStatus'?: BackupJobStatus;
    /**
     * 
     * @type {string}
     * @memberof DatabaseResponseDto
     */
    'backupJobStatusText'?: string | null;
    /**
     * 
     * @type {ValidationJobStatus}
     * @memberof DatabaseResponseDto
     */
    'validationJobStatus'?: ValidationJobStatus;
    /**
     * 
     * @type {string}
     * @memberof DatabaseResponseDto
     */
    'validationJobStatusText'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DatabaseResponseDto
     */
    'rto'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof DatabaseResponseDto
     */
    'rpo'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof DatabaseResponseDto
     */
    'lastBackupSuccessTime'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DatabaseResponseDto
     */
    'isManaged'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DatabaseResponseDto
     */
    'isDeleted'?: boolean;
}
/**
 * 
 * @export
 * @interface DatabaseSchemaInput
 */
export interface DatabaseSchemaInput {
    /**
     * 
     * @type {number}
     * @memberof DatabaseSchemaInput
     */
    'databaseId'?: number;
    /**
     * 
     * @type {number}
     * @memberof DatabaseSchemaInput
     */
    'backupId'?: number;
    /**
     * 
     * @type {string}
     * @memberof DatabaseSchemaInput
     */
    'validationCode': string;
    /**
     * 
     * @type {Array<TableInfoInput>}
     * @memberof DatabaseSchemaInput
     */
    'tables'?: Array<TableInfoInput> | null;
    /**
     * 
     * @type {Array<FieldInfoInput>}
     * @memberof DatabaseSchemaInput
     */
    'fields'?: Array<FieldInfoInput> | null;
    /**
     * 
     * @type {Array<PrimaryKeyInfoInput>}
     * @memberof DatabaseSchemaInput
     */
    'primaryKeys'?: Array<PrimaryKeyInfoInput> | null;
    /**
     * 
     * @type {Array<ForeignKeyInfoInput>}
     * @memberof DatabaseSchemaInput
     */
    'foreignKeys'?: Array<ForeignKeyInfoInput> | null;
    /**
     * 
     * @type {Array<TriggerInfoInput>}
     * @memberof DatabaseSchemaInput
     */
    'triggers'?: Array<TriggerInfoInput> | null;
    /**
     * 
     * @type {Array<IndexInfoInput>}
     * @memberof DatabaseSchemaInput
     */
    'indexes'?: Array<IndexInfoInput> | null;
    /**
     * 
     * @type {Array<ProcedureInfoInput>}
     * @memberof DatabaseSchemaInput
     */
    'procedures'?: Array<ProcedureInfoInput> | null;
    /**
     * 
     * @type {Array<ViewInfoInput>}
     * @memberof DatabaseSchemaInput
     */
    'views'?: Array<ViewInfoInput> | null;
    /**
     * 
     * @type {Array<ViewFieldInfoInput>}
     * @memberof DatabaseSchemaInput
     */
    'viewFields'?: Array<ViewFieldInfoInput> | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export enum DatabaseType {
    MySQL = 1,
    PostgreSQL = 2,
    SQLServer = 3,
    MongoDB = 4,
    MariaDB = 5,
    Oracle = 6,
    DB2 = 7,
    Hana = 8,
    Snowflake = 9,
    CosmosDB = 10
}

/**
 * 
 * @export
 * @interface DecryptThenEncryptInput
 */
export interface DecryptThenEncryptInput {
    /**
     * 
     * @type {number}
     * @memberof DecryptThenEncryptInput
     */
    'organizationId'?: number;
    /**
     * 
     * @type {string}
     * @memberof DecryptThenEncryptInput
     */
    'publicXml'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DecryptThenEncryptInput
     */
    'encryptedBytes'?: string | null;
}
/**
 * 
 * @export
 * @interface DownloadAuthenticateInput
 */
export interface DownloadAuthenticateInput {
    /**
     * 
     * @type {number}
     * @memberof DownloadAuthenticateInput
     */
    'databaseId'?: number;
    /**
     * 
     * @type {number}
     * @memberof DownloadAuthenticateInput
     */
    'backupId'?: number;
    /**
     * 
     * @type {number}
     * @memberof DownloadAuthenticateInput
     */
    'downloadId'?: number;
    /**
     * 
     * @type {string}
     * @memberof DownloadAuthenticateInput
     */
    'publicKey'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DownloadAuthenticateInput
     */
    'message'?: string | null;
}
/**
 * 
 * @export
 * @interface EngineResponseDto
 */
export interface EngineResponseDto {
    /**
     * 
     * @type {number}
     * @memberof EngineResponseDto
     */
    'id'?: number;
    /**
     * 
     * @type {DatabaseType}
     * @memberof EngineResponseDto
     */
    'databaseType'?: DatabaseType;
    /**
     * 
     * @type {string}
     * @memberof EngineResponseDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EngineResponseDto
     */
    'version'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EngineResponseDto
     */
    'edition'?: string | null;
    /**
     * 
     * @type {EngineStatus}
     * @memberof EngineResponseDto
     */
    'status'?: EngineStatus;
    /**
     * 
     * @type {boolean}
     * @memberof EngineResponseDto
     */
    'isDeleted'?: boolean;
}
/**
 * 
 * @export
 * @enum {string}
 */

export enum EngineStatus {
    Production = 0,
    Beta = 1,
    EOL = 2
}

/**
 * 
 * @export
 * @interface EnumOptionResponseDto
 */
export interface EnumOptionResponseDto {
    /**
     * 
     * @type {number}
     * @memberof EnumOptionResponseDto
     */
    'key'?: number;
    /**
     * 
     * @type {string}
     * @memberof EnumOptionResponseDto
     */
    'text'?: string | null;
    /**
     * 
     * @type {DatabaseType}
     * @memberof EnumOptionResponseDto
     */
    'databaseType'?: DatabaseType;
}
/**
 * 
 * @export
 * @interface FieldInfoInput
 */
export interface FieldInfoInput {
    /**
     * 
     * @type {string}
     * @memberof FieldInfoInput
     */
    'tableSchema'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FieldInfoInput
     */
    'tableName': string;
    /**
     * 
     * @type {string}
     * @memberof FieldInfoInput
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof FieldInfoInput
     */
    'type'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof FieldInfoInput
     */
    'position': number;
    /**
     * 
     * @type {number}
     * @memberof FieldInfoInput
     */
    'maxLength'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof FieldInfoInput
     */
    'precision'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof FieldInfoInput
     */
    'scale'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof FieldInfoInput
     */
    'isNullable'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FieldInfoInput
     */
    'isIdentity'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FieldInfoInput
     */
    'isComputed'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FieldInfoInput
     */
    'isRowVersionGA'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof FieldInfoInput
     */
    'defaultValue'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FieldInfoInput
     */
    'comment'?: string | null;
}
/**
 * 
 * @export
 * @interface ForeignKeyInfoInput
 */
export interface ForeignKeyInfoInput {
    /**
     * 
     * @type {string}
     * @memberof ForeignKeyInfoInput
     */
    'tableSchema'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ForeignKeyInfoInput
     */
    'tableName': string;
    /**
     * 
     * @type {string}
     * @memberof ForeignKeyInfoInput
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof ForeignKeyInfoInput
     */
    'position'?: number;
    /**
     * 
     * @type {string}
     * @memberof ForeignKeyInfoInput
     */
    'columnName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ForeignKeyInfoInput
     */
    'referencedSchemaName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ForeignKeyInfoInput
     */
    'referencedTableName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ForeignKeyInfoInput
     */
    'referencedPositon'?: number;
    /**
     * 
     * @type {string}
     * @memberof ForeignKeyInfoInput
     */
    'referencedColumnName'?: string | null;
}
/**
 * 
 * @export
 * @interface GetBackupFilesWithUriInput
 */
export interface GetBackupFilesWithUriInput {
    /**
     * 
     * @type {number}
     * @memberof GetBackupFilesWithUriInput
     */
    'databaseId'?: number;
    /**
     * 
     * @type {number}
     * @memberof GetBackupFilesWithUriInput
     */
    'backupId'?: number;
    /**
     * 
     * @type {string}
     * @memberof GetBackupFilesWithUriInput
     */
    'publicKeyXml': string;
    /**
     * 
     * @type {string}
     * @memberof GetBackupFilesWithUriInput
     */
    'validationCode': string;
}
/**
 * 
 * @export
 * @interface IndexInfoInput
 */
export interface IndexInfoInput {
    /**
     * 
     * @type {string}
     * @memberof IndexInfoInput
     */
    'tableSchema'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IndexInfoInput
     */
    'tableName': string;
    /**
     * 
     * @type {string}
     * @memberof IndexInfoInput
     */
    'name': string;
    /**
     * 
     * @type {boolean}
     * @memberof IndexInfoInput
     */
    'isPrimaryKey'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IndexInfoInput
     */
    'isUnique'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IndexInfoInput
     */
    'isClustered'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof IndexInfoInput
     */
    'position'?: number;
    /**
     * 
     * @type {string}
     * @memberof IndexInfoInput
     */
    'columnName'?: string | null;
}
/**
 * 
 * @export
 * @interface InternalListBackupsInput
 */
export interface InternalListBackupsInput {
    /**
     * 
     * @type {number}
     * @memberof InternalListBackupsInput
     */
    'organizationId'?: number;
    /**
     * 
     * @type {number}
     * @memberof InternalListBackupsInput
     */
    'databaseId'?: number;
    /**
     * 
     * @type {Array<number>}
     * @memberof InternalListBackupsInput
     */
    'backupIds'?: Array<number> | null;
}
/**
 * 
 * @export
 * @interface NoSqlDatabaseSchemaInput
 */
export interface NoSqlDatabaseSchemaInput {
    /**
     * 
     * @type {number}
     * @memberof NoSqlDatabaseSchemaInput
     */
    'databaseId'?: number;
    /**
     * 
     * @type {string}
     * @memberof NoSqlDatabaseSchemaInput
     */
    'databaseName'?: string | null;
    /**
     * 
     * @type {Array<CollectionInfoInput>}
     * @memberof NoSqlDatabaseSchemaInput
     */
    'collections'?: Array<CollectionInfoInput> | null;
    /**
     * 
     * @type {Array<PropertyInfoInput>}
     * @memberof NoSqlDatabaseSchemaInput
     */
    'properties'?: Array<PropertyInfoInput> | null;
}
/**
 * 
 * @export
 * @interface PrimaryKeyInfoInput
 */
export interface PrimaryKeyInfoInput {
    /**
     * 
     * @type {string}
     * @memberof PrimaryKeyInfoInput
     */
    'tableSchema'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PrimaryKeyInfoInput
     */
    'tableName': string;
    /**
     * 
     * @type {string}
     * @memberof PrimaryKeyInfoInput
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof PrimaryKeyInfoInput
     */
    'position'?: number;
    /**
     * 
     * @type {string}
     * @memberof PrimaryKeyInfoInput
     */
    'columnName'?: string | null;
}
/**
 * 
 * @export
 * @interface ProcedureInfoInput
 */
export interface ProcedureInfoInput {
    /**
     * 
     * @type {string}
     * @memberof ProcedureInfoInput
     */
    'schema'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProcedureInfoInput
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof ProcedureInfoInput
     */
    'definition'?: string | null;
}
/**
 * 
 * @export
 * @interface PropertyInfoInput
 */
export interface PropertyInfoInput {
    /**
     * 
     * @type {string}
     * @memberof PropertyInfoInput
     */
    'collectionName': string;
    /**
     * 
     * @type {string}
     * @memberof PropertyInfoInput
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof PropertyInfoInput
     */
    'type'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof PropertyInfoInput
     */
    'precision'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PropertyInfoInput
     */
    'scale'?: number | null;
}
/**
 * 
 * @export
 * @interface ReportResultInput
 */
export interface ReportResultInput {
    /**
     * 
     * @type {number}
     * @memberof ReportResultInput
     */
    'databaseId'?: number;
    /**
     * 
     * @type {number}
     * @memberof ReportResultInput
     */
    'backupId'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ReportResultInput
     */
    'isSuccess'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ReportResultInput
     */
    'log'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReportResultInput
     */
    'exception'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReportResultInput
     */
    'validationCode'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ReportResultInput
     */
    'isEncoded'?: boolean;
}
/**
 * 
 * @export
 * @enum {string}
 */

export enum ResultLevel {
    Success = 0,
    Warning = 1,
    Failed = 2
}

/**
 * 
 * @export
 * @interface SchemaOnlyBackupInput
 */
export interface SchemaOnlyBackupInput {
    /**
     * 
     * @type {number}
     * @memberof SchemaOnlyBackupInput
     */
    'databaseId'?: number;
    /**
     * 
     * @type {string}
     * @memberof SchemaOnlyBackupInput
     */
    'databaseName'?: string | null;
    /**
     * 
     * @type {Array<TableInfoInput>}
     * @memberof SchemaOnlyBackupInput
     */
    'tables'?: Array<TableInfoInput> | null;
    /**
     * 
     * @type {Array<FieldInfoInput>}
     * @memberof SchemaOnlyBackupInput
     */
    'fields'?: Array<FieldInfoInput> | null;
    /**
     * 
     * @type {Array<PrimaryKeyInfoInput>}
     * @memberof SchemaOnlyBackupInput
     */
    'primaryKeys'?: Array<PrimaryKeyInfoInput> | null;
    /**
     * 
     * @type {Array<ForeignKeyInfoInput>}
     * @memberof SchemaOnlyBackupInput
     */
    'foreignKeys'?: Array<ForeignKeyInfoInput> | null;
    /**
     * 
     * @type {Array<TriggerInfoInput>}
     * @memberof SchemaOnlyBackupInput
     */
    'triggers'?: Array<TriggerInfoInput> | null;
    /**
     * 
     * @type {Array<IndexInfoInput>}
     * @memberof SchemaOnlyBackupInput
     */
    'indexes'?: Array<IndexInfoInput> | null;
    /**
     * 
     * @type {Array<ProcedureInfoInput>}
     * @memberof SchemaOnlyBackupInput
     */
    'procedures'?: Array<ProcedureInfoInput> | null;
    /**
     * 
     * @type {Array<ViewInfoInput>}
     * @memberof SchemaOnlyBackupInput
     */
    'views'?: Array<ViewInfoInput> | null;
    /**
     * 
     * @type {Array<ViewFieldInfoInput>}
     * @memberof SchemaOnlyBackupInput
     */
    'viewFields'?: Array<ViewFieldInfoInput> | null;
}
/**
 * 
 * @export
 * @interface SignDataInput
 */
export interface SignDataInput {
    /**
     * 
     * @type {string}
     * @memberof SignDataInput
     */
    'dataToSign': string;
}
/**
 * 
 * @export
 * @interface TableInfoInput
 */
export interface TableInfoInput {
    /**
     * 
     * @type {string}
     * @memberof TableInfoInput
     */
    'schema'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TableInfoInput
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof TableInfoInput
     */
    'comment'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof TableInfoInput
     */
    'totalRows'?: number | null;
}
/**
 * 
 * @export
 * @interface TriggerInfoInput
 */
export interface TriggerInfoInput {
    /**
     * 
     * @type {string}
     * @memberof TriggerInfoInput
     */
    'tableSchema'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TriggerInfoInput
     */
    'tableName': string;
    /**
     * 
     * @type {string}
     * @memberof TriggerInfoInput
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof TriggerInfoInput
     */
    'eventManipulation'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TriggerInfoInput
     */
    'actionTimming'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TriggerInfoInput
     */
    'actionOrientation'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TriggerInfoInput
     */
    'actionStatement'?: string | null;
}
/**
 * 
 * @export
 * @interface UpdateDatabaseInput
 */
export interface UpdateDatabaseInput {
    /**
     * 
     * @type {number}
     * @memberof UpdateDatabaseInput
     */
    'databaseId': number;
    /**
     * 
     * @type {string}
     * @memberof UpdateDatabaseInput
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof UpdateDatabaseInput
     */
    'engineId': number;
    /**
     * 
     * @type {string}
     * @memberof UpdateDatabaseInput
     */
    'description'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateDatabaseInput
     */
    'retentionDaysId'?: number;
}
/**
 * 
 * @export
 * @interface ValidateDownloadFileInput
 */
export interface ValidateDownloadFileInput {
    /**
     * 
     * @type {number}
     * @memberof ValidateDownloadFileInput
     */
    'organizationId'?: number;
    /**
     * 
     * @type {number}
     * @memberof ValidateDownloadFileInput
     */
    'databaseId'?: number;
    /**
     * 
     * @type {number}
     * @memberof ValidateDownloadFileInput
     */
    'backupId'?: number;
    /**
     * 
     * @type {number}
     * @memberof ValidateDownloadFileInput
     */
    'downloadId'?: number;
    /**
     * 
     * @type {number}
     * @memberof ValidateDownloadFileInput
     */
    'fileId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ValidateDownloadFileInput
     */
    'guid': string;
    /**
     * 
     * @type {string}
     * @memberof ValidateDownloadFileInput
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof ValidateDownloadFileInput
     */
    'code': string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export enum ValidationFrequency {
    Hourly = 1,
    Daily = 2,
    Weekly = 3,
    Monthly = 4
}

/**
 * 
 * @export
 * @enum {string}
 */

export enum ValidationJobStatus {
    NoValidation = 0,
    InProgress = 1,
    Validated = 2,
    Failed = 3
}

/**
 * 
 * @export
 * @interface ValidationScheduleInput
 */
export interface ValidationScheduleInput {
    /**
     * 
     * @type {number}
     * @memberof ValidationScheduleInput
     */
    'databaseId'?: number;
    /**
     * 
     * @type {ValidationFrequency}
     * @memberof ValidationScheduleInput
     */
    'frequency'?: ValidationFrequency;
    /**
     * 
     * @type {number}
     * @memberof ValidationScheduleInput
     */
    'interval'?: number;
    /**
     * 
     * @type {number}
     * @memberof ValidationScheduleInput
     */
    'startHour'?: number;
    /**
     * 
     * @type {number}
     * @memberof ValidationScheduleInput
     */
    'startMinute'?: number;
    /**
     * 
     * @type {string}
     * @memberof ValidationScheduleInput
     */
    'daysOfWeek'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ValidationScheduleInput
     */
    'dayOfMonth'?: number;
}
/**
 * 
 * @export
 * @interface ValidationScheduleResponseDto
 */
export interface ValidationScheduleResponseDto {
    /**
     * 
     * @type {number}
     * @memberof ValidationScheduleResponseDto
     */
    'organizationId'?: number;
    /**
     * 
     * @type {number}
     * @memberof ValidationScheduleResponseDto
     */
    'databaseId'?: number;
    /**
     * 
     * @type {ValidationFrequency}
     * @memberof ValidationScheduleResponseDto
     */
    'frequency'?: ValidationFrequency;
    /**
     * 
     * @type {number}
     * @memberof ValidationScheduleResponseDto
     */
    'interval'?: number;
    /**
     * 
     * @type {number}
     * @memberof ValidationScheduleResponseDto
     */
    'startHour'?: number;
    /**
     * 
     * @type {number}
     * @memberof ValidationScheduleResponseDto
     */
    'startMinute'?: number;
    /**
     * 
     * @type {string}
     * @memberof ValidationScheduleResponseDto
     */
    'daysOfWeek'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ValidationScheduleResponseDto
     */
    'dayOfMonth'?: number;
    /**
     * 
     * @type {string}
     * @memberof ValidationScheduleResponseDto
     */
    'cronExpression'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ValidationScheduleResponseDto
     */
    'timeZoneName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ValidationScheduleResponseDto
     */
    'timeZoneOffset'?: string | null;
}
/**
 * 
 * @export
 * @interface ViewFieldInfoInput
 */
export interface ViewFieldInfoInput {
    /**
     * 
     * @type {string}
     * @memberof ViewFieldInfoInput
     */
    'viewSchema'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ViewFieldInfoInput
     */
    'viewName': string;
    /**
     * 
     * @type {string}
     * @memberof ViewFieldInfoInput
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof ViewFieldInfoInput
     */
    'type'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ViewFieldInfoInput
     */
    'position': number;
    /**
     * 
     * @type {number}
     * @memberof ViewFieldInfoInput
     */
    'maxLength'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ViewFieldInfoInput
     */
    'precision'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ViewFieldInfoInput
     */
    'scale'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ViewFieldInfoInput
     */
    'sourceDatabaseName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ViewFieldInfoInput
     */
    'sourceSchemaName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ViewFieldInfoInput
     */
    'sourceTableName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ViewFieldInfoInput
     */
    'sourceColumnName'?: string | null;
}
/**
 * 
 * @export
 * @interface ViewInfoInput
 */
export interface ViewInfoInput {
    /**
     * 
     * @type {string}
     * @memberof ViewInfoInput
     */
    'schema'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ViewInfoInput
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof ViewInfoInput
     */
    'viewDefinition': string;
}

/**
 * BackupApi - axios parameter creator
 * @export
 */
export const BackupApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBackupDashboardGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/backup/dashboard`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [databaseId] 
         * @param {number} [page] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBackupDetailsGet: async (databaseId?: number, page?: number, limit?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/backup/details`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (databaseId !== undefined) {
                localVarQueryParameter['databaseId'] = databaseId;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [databaseId] 
         * @param {number} [backupId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBackupDownloadGet: async (databaseId?: number, backupId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/backup/download`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (databaseId !== undefined) {
                localVarQueryParameter['databaseId'] = databaseId;
            }

            if (backupId !== undefined) {
                localVarQueryParameter['backupId'] = backupId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [databaseId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBackupEncryptableGet: async (databaseId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/backup/encryptable`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (databaseId !== undefined) {
                localVarQueryParameter['databaseId'] = databaseId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {DatabaseType} [databaseType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBackupEnginesGet: async (databaseType?: DatabaseType, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/backup/engines`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (databaseType !== undefined) {
                localVarQueryParameter['databaseType'] = databaseType;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBackupRetentiondaysGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/backup/retentiondays`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [databaseId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBackupUploadconfigGet: async (databaseId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/backup/uploadconfig`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (databaseId !== undefined) {
                localVarQueryParameter['databaseId'] = databaseId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BackupApi - functional programming interface
 * @export
 */
export const BackupApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BackupApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiBackupDashboardGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BackupDashboardResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiBackupDashboardGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [databaseId] 
         * @param {number} [page] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiBackupDetailsGet(databaseId?: number, page?: number, limit?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BackupResponseDtoPaginationResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiBackupDetailsGet(databaseId, page, limit, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [databaseId] 
         * @param {number} [backupId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiBackupDownloadGet(databaseId?: number, backupId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiBackupDownloadGet(databaseId, backupId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [databaseId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiBackupEncryptableGet(databaseId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<BackupResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiBackupEncryptableGet(databaseId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {DatabaseType} [databaseType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiBackupEnginesGet(databaseType?: DatabaseType, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EngineResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiBackupEnginesGet(databaseType, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiBackupRetentiondaysGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EnumOptionResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiBackupRetentiondaysGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [databaseId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiBackupUploadconfigGet(databaseId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiBackupUploadconfigGet(databaseId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * BackupApi - factory interface
 * @export
 */
export const BackupApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BackupApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBackupDashboardGet(options?: any): AxiosPromise<BackupDashboardResponseDto> {
            return localVarFp.apiBackupDashboardGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [databaseId] 
         * @param {number} [page] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBackupDetailsGet(databaseId?: number, page?: number, limit?: number, options?: any): AxiosPromise<BackupResponseDtoPaginationResult> {
            return localVarFp.apiBackupDetailsGet(databaseId, page, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [databaseId] 
         * @param {number} [backupId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBackupDownloadGet(databaseId?: number, backupId?: number, options?: any): AxiosPromise<any> {
            return localVarFp.apiBackupDownloadGet(databaseId, backupId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [databaseId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBackupEncryptableGet(databaseId?: number, options?: any): AxiosPromise<Array<BackupResponseDto>> {
            return localVarFp.apiBackupEncryptableGet(databaseId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DatabaseType} [databaseType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBackupEnginesGet(databaseType?: DatabaseType, options?: any): AxiosPromise<Array<EngineResponseDto>> {
            return localVarFp.apiBackupEnginesGet(databaseType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBackupRetentiondaysGet(options?: any): AxiosPromise<Array<EnumOptionResponseDto>> {
            return localVarFp.apiBackupRetentiondaysGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [databaseId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBackupUploadconfigGet(databaseId?: number, options?: any): AxiosPromise<any> {
            return localVarFp.apiBackupUploadconfigGet(databaseId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BackupApi - object-oriented interface
 * @export
 * @class BackupApi
 * @extends {BaseAPI}
 */
export class BackupApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackupApi
     */
    public apiBackupDashboardGet(options?: AxiosRequestConfig) {
        return BackupApiFp(this.configuration).apiBackupDashboardGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [databaseId] 
     * @param {number} [page] 
     * @param {number} [limit] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackupApi
     */
    public apiBackupDetailsGet(databaseId?: number, page?: number, limit?: number, options?: AxiosRequestConfig) {
        return BackupApiFp(this.configuration).apiBackupDetailsGet(databaseId, page, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [databaseId] 
     * @param {number} [backupId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackupApi
     */
    public apiBackupDownloadGet(databaseId?: number, backupId?: number, options?: AxiosRequestConfig) {
        return BackupApiFp(this.configuration).apiBackupDownloadGet(databaseId, backupId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [databaseId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackupApi
     */
    public apiBackupEncryptableGet(databaseId?: number, options?: AxiosRequestConfig) {
        return BackupApiFp(this.configuration).apiBackupEncryptableGet(databaseId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DatabaseType} [databaseType] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackupApi
     */
    public apiBackupEnginesGet(databaseType?: DatabaseType, options?: AxiosRequestConfig) {
        return BackupApiFp(this.configuration).apiBackupEnginesGet(databaseType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackupApi
     */
    public apiBackupRetentiondaysGet(options?: AxiosRequestConfig) {
        return BackupApiFp(this.configuration).apiBackupRetentiondaysGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [databaseId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackupApi
     */
    public apiBackupUploadconfigGet(databaseId?: number, options?: AxiosRequestConfig) {
        return BackupApiFp(this.configuration).apiBackupUploadconfigGet(databaseId, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * DatabasesApi - axios parameter creator
 * @export
 */
export const DatabasesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} databaseId 
         * @param {BackupType} backupType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDatabasesDatabaseIdBackupscheduleBackupTypeDelete: async (databaseId: number, backupType: BackupType, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'databaseId' is not null or undefined
            assertParamExists('apiDatabasesDatabaseIdBackupscheduleBackupTypeDelete', 'databaseId', databaseId)
            // verify required parameter 'backupType' is not null or undefined
            assertParamExists('apiDatabasesDatabaseIdBackupscheduleBackupTypeDelete', 'backupType', backupType)
            const localVarPath = `/api/databases/{databaseId}/backupschedule/{backupType}`
                .replace(`{${"databaseId"}}`, encodeURIComponent(String(databaseId)))
                .replace(`{${"backupType"}}`, encodeURIComponent(String(backupType)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} databaseId 
         * @param {BackupType} backupType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDatabasesDatabaseIdBackupscheduleBackupTypeGet: async (databaseId: number, backupType: BackupType, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'databaseId' is not null or undefined
            assertParamExists('apiDatabasesDatabaseIdBackupscheduleBackupTypeGet', 'databaseId', databaseId)
            // verify required parameter 'backupType' is not null or undefined
            assertParamExists('apiDatabasesDatabaseIdBackupscheduleBackupTypeGet', 'backupType', backupType)
            const localVarPath = `/api/databases/{databaseId}/backupschedule/{backupType}`
                .replace(`{${"databaseId"}}`, encodeURIComponent(String(databaseId)))
                .replace(`{${"backupType"}}`, encodeURIComponent(String(backupType)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} databaseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDatabasesDatabaseIdBackupscheduleGet: async (databaseId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'databaseId' is not null or undefined
            assertParamExists('apiDatabasesDatabaseIdBackupscheduleGet', 'databaseId', databaseId)
            const localVarPath = `/api/databases/{databaseId}/backupschedule`
                .replace(`{${"databaseId"}}`, encodeURIComponent(String(databaseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} databaseId 
         * @param {BackupScheduleInput} [backupScheduleInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDatabasesDatabaseIdBackupschedulePost: async (databaseId: number, backupScheduleInput?: BackupScheduleInput, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'databaseId' is not null or undefined
            assertParamExists('apiDatabasesDatabaseIdBackupschedulePost', 'databaseId', databaseId)
            const localVarPath = `/api/databases/{databaseId}/backupschedule`
                .replace(`{${"databaseId"}}`, encodeURIComponent(String(databaseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(backupScheduleInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} databaseId 
         * @param {BackupScheduleInput} [backupScheduleInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDatabasesDatabaseIdBackupschedulePut: async (databaseId: number, backupScheduleInput?: BackupScheduleInput, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'databaseId' is not null or undefined
            assertParamExists('apiDatabasesDatabaseIdBackupschedulePut', 'databaseId', databaseId)
            const localVarPath = `/api/databases/{databaseId}/backupschedule`
                .replace(`{${"databaseId"}}`, encodeURIComponent(String(databaseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(backupScheduleInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} databaseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDatabasesDatabaseIdBackuptypesGet: async (databaseId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'databaseId' is not null or undefined
            assertParamExists('apiDatabasesDatabaseIdBackuptypesGet', 'databaseId', databaseId)
            const localVarPath = `/api/databases/{databaseId}/backuptypes`
                .replace(`{${"databaseId"}}`, encodeURIComponent(String(databaseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} databaseId 
         * @param {CloneDatabaseInput} [cloneDatabaseInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDatabasesDatabaseIdClonePost: async (databaseId: number, cloneDatabaseInput?: CloneDatabaseInput, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'databaseId' is not null or undefined
            assertParamExists('apiDatabasesDatabaseIdClonePost', 'databaseId', databaseId)
            const localVarPath = `/api/databases/{databaseId}/clone`
                .replace(`{${"databaseId"}}`, encodeURIComponent(String(databaseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(cloneDatabaseInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} databaseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDatabasesDatabaseIdDelete: async (databaseId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'databaseId' is not null or undefined
            assertParamExists('apiDatabasesDatabaseIdDelete', 'databaseId', databaseId)
            const localVarPath = `/api/databases/{databaseId}`
                .replace(`{${"databaseId"}}`, encodeURIComponent(String(databaseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} databaseId 
         * @param {UpdateDatabaseInput} [updateDatabaseInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDatabasesDatabaseIdPut: async (databaseId: number, updateDatabaseInput?: UpdateDatabaseInput, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'databaseId' is not null or undefined
            assertParamExists('apiDatabasesDatabaseIdPut', 'databaseId', databaseId)
            const localVarPath = `/api/databases/{databaseId}`
                .replace(`{${"databaseId"}}`, encodeURIComponent(String(databaseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateDatabaseInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} databaseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDatabasesDatabaseIdValidationscheduleGet: async (databaseId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'databaseId' is not null or undefined
            assertParamExists('apiDatabasesDatabaseIdValidationscheduleGet', 'databaseId', databaseId)
            const localVarPath = `/api/databases/{databaseId}/validationschedule`
                .replace(`{${"databaseId"}}`, encodeURIComponent(String(databaseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} databaseId 
         * @param {ValidationScheduleInput} [validationScheduleInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDatabasesDatabaseIdValidationschedulePut: async (databaseId: number, validationScheduleInput?: ValidationScheduleInput, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'databaseId' is not null or undefined
            assertParamExists('apiDatabasesDatabaseIdValidationschedulePut', 'databaseId', databaseId)
            const localVarPath = `/api/databases/{databaseId}/validationschedule`
                .replace(`{${"databaseId"}}`, encodeURIComponent(String(databaseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(validationScheduleInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDatabasesGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/databases`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateDatabaseInput} [createDatabaseInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDatabasesPost: async (createDatabaseInput?: CreateDatabaseInput, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/databases`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createDatabaseInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDatabasesTypesGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/databases/types`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DatabasesApi - functional programming interface
 * @export
 */
export const DatabasesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DatabasesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} databaseId 
         * @param {BackupType} backupType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDatabasesDatabaseIdBackupscheduleBackupTypeDelete(databaseId: number, backupType: BackupType, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDatabasesDatabaseIdBackupscheduleBackupTypeDelete(databaseId, backupType, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} databaseId 
         * @param {BackupType} backupType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDatabasesDatabaseIdBackupscheduleBackupTypeGet(databaseId: number, backupType: BackupType, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BackupScheduleResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDatabasesDatabaseIdBackupscheduleBackupTypeGet(databaseId, backupType, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} databaseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDatabasesDatabaseIdBackupscheduleGet(databaseId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<BackupScheduleResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDatabasesDatabaseIdBackupscheduleGet(databaseId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} databaseId 
         * @param {BackupScheduleInput} [backupScheduleInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDatabasesDatabaseIdBackupschedulePost(databaseId: number, backupScheduleInput?: BackupScheduleInput, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDatabasesDatabaseIdBackupschedulePost(databaseId, backupScheduleInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} databaseId 
         * @param {BackupScheduleInput} [backupScheduleInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDatabasesDatabaseIdBackupschedulePut(databaseId: number, backupScheduleInput?: BackupScheduleInput, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDatabasesDatabaseIdBackupschedulePut(databaseId, backupScheduleInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} databaseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDatabasesDatabaseIdBackuptypesGet(databaseId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<BackupTypeResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDatabasesDatabaseIdBackuptypesGet(databaseId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} databaseId 
         * @param {CloneDatabaseInput} [cloneDatabaseInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDatabasesDatabaseIdClonePost(databaseId: number, cloneDatabaseInput?: CloneDatabaseInput, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDatabasesDatabaseIdClonePost(databaseId, cloneDatabaseInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} databaseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDatabasesDatabaseIdDelete(databaseId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDatabasesDatabaseIdDelete(databaseId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} databaseId 
         * @param {UpdateDatabaseInput} [updateDatabaseInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDatabasesDatabaseIdPut(databaseId: number, updateDatabaseInput?: UpdateDatabaseInput, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDatabasesDatabaseIdPut(databaseId, updateDatabaseInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} databaseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDatabasesDatabaseIdValidationscheduleGet(databaseId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ValidationScheduleResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDatabasesDatabaseIdValidationscheduleGet(databaseId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} databaseId 
         * @param {ValidationScheduleInput} [validationScheduleInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDatabasesDatabaseIdValidationschedulePut(databaseId: number, validationScheduleInput?: ValidationScheduleInput, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDatabasesDatabaseIdValidationschedulePut(databaseId, validationScheduleInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDatabasesGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DatabaseResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDatabasesGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CreateDatabaseInput} [createDatabaseInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDatabasesPost(createDatabaseInput?: CreateDatabaseInput, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDatabasesPost(createDatabaseInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDatabasesTypesGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EnumOptionResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDatabasesTypesGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DatabasesApi - factory interface
 * @export
 */
export const DatabasesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DatabasesApiFp(configuration)
    return {
        /**
         * 
         * @param {number} databaseId 
         * @param {BackupType} backupType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDatabasesDatabaseIdBackupscheduleBackupTypeDelete(databaseId: number, backupType: BackupType, options?: any): AxiosPromise<void> {
            return localVarFp.apiDatabasesDatabaseIdBackupscheduleBackupTypeDelete(databaseId, backupType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} databaseId 
         * @param {BackupType} backupType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDatabasesDatabaseIdBackupscheduleBackupTypeGet(databaseId: number, backupType: BackupType, options?: any): AxiosPromise<BackupScheduleResponseDto> {
            return localVarFp.apiDatabasesDatabaseIdBackupscheduleBackupTypeGet(databaseId, backupType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} databaseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDatabasesDatabaseIdBackupscheduleGet(databaseId: number, options?: any): AxiosPromise<Array<BackupScheduleResponseDto>> {
            return localVarFp.apiDatabasesDatabaseIdBackupscheduleGet(databaseId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} databaseId 
         * @param {BackupScheduleInput} [backupScheduleInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDatabasesDatabaseIdBackupschedulePost(databaseId: number, backupScheduleInput?: BackupScheduleInput, options?: any): AxiosPromise<void> {
            return localVarFp.apiDatabasesDatabaseIdBackupschedulePost(databaseId, backupScheduleInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} databaseId 
         * @param {BackupScheduleInput} [backupScheduleInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDatabasesDatabaseIdBackupschedulePut(databaseId: number, backupScheduleInput?: BackupScheduleInput, options?: any): AxiosPromise<void> {
            return localVarFp.apiDatabasesDatabaseIdBackupschedulePut(databaseId, backupScheduleInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} databaseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDatabasesDatabaseIdBackuptypesGet(databaseId: number, options?: any): AxiosPromise<Array<BackupTypeResponseDto>> {
            return localVarFp.apiDatabasesDatabaseIdBackuptypesGet(databaseId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} databaseId 
         * @param {CloneDatabaseInput} [cloneDatabaseInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDatabasesDatabaseIdClonePost(databaseId: number, cloneDatabaseInput?: CloneDatabaseInput, options?: any): AxiosPromise<number> {
            return localVarFp.apiDatabasesDatabaseIdClonePost(databaseId, cloneDatabaseInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} databaseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDatabasesDatabaseIdDelete(databaseId: number, options?: any): AxiosPromise<void> {
            return localVarFp.apiDatabasesDatabaseIdDelete(databaseId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} databaseId 
         * @param {UpdateDatabaseInput} [updateDatabaseInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDatabasesDatabaseIdPut(databaseId: number, updateDatabaseInput?: UpdateDatabaseInput, options?: any): AxiosPromise<void> {
            return localVarFp.apiDatabasesDatabaseIdPut(databaseId, updateDatabaseInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} databaseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDatabasesDatabaseIdValidationscheduleGet(databaseId: number, options?: any): AxiosPromise<ValidationScheduleResponseDto> {
            return localVarFp.apiDatabasesDatabaseIdValidationscheduleGet(databaseId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} databaseId 
         * @param {ValidationScheduleInput} [validationScheduleInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDatabasesDatabaseIdValidationschedulePut(databaseId: number, validationScheduleInput?: ValidationScheduleInput, options?: any): AxiosPromise<void> {
            return localVarFp.apiDatabasesDatabaseIdValidationschedulePut(databaseId, validationScheduleInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDatabasesGet(options?: any): AxiosPromise<Array<DatabaseResponseDto>> {
            return localVarFp.apiDatabasesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateDatabaseInput} [createDatabaseInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDatabasesPost(createDatabaseInput?: CreateDatabaseInput, options?: any): AxiosPromise<number> {
            return localVarFp.apiDatabasesPost(createDatabaseInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDatabasesTypesGet(options?: any): AxiosPromise<Array<EnumOptionResponseDto>> {
            return localVarFp.apiDatabasesTypesGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DatabasesApi - object-oriented interface
 * @export
 * @class DatabasesApi
 * @extends {BaseAPI}
 */
export class DatabasesApi extends BaseAPI {
    /**
     * 
     * @param {number} databaseId 
     * @param {BackupType} backupType 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DatabasesApi
     */
    public apiDatabasesDatabaseIdBackupscheduleBackupTypeDelete(databaseId: number, backupType: BackupType, options?: AxiosRequestConfig) {
        return DatabasesApiFp(this.configuration).apiDatabasesDatabaseIdBackupscheduleBackupTypeDelete(databaseId, backupType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} databaseId 
     * @param {BackupType} backupType 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DatabasesApi
     */
    public apiDatabasesDatabaseIdBackupscheduleBackupTypeGet(databaseId: number, backupType: BackupType, options?: AxiosRequestConfig) {
        return DatabasesApiFp(this.configuration).apiDatabasesDatabaseIdBackupscheduleBackupTypeGet(databaseId, backupType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} databaseId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DatabasesApi
     */
    public apiDatabasesDatabaseIdBackupscheduleGet(databaseId: number, options?: AxiosRequestConfig) {
        return DatabasesApiFp(this.configuration).apiDatabasesDatabaseIdBackupscheduleGet(databaseId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} databaseId 
     * @param {BackupScheduleInput} [backupScheduleInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DatabasesApi
     */
    public apiDatabasesDatabaseIdBackupschedulePost(databaseId: number, backupScheduleInput?: BackupScheduleInput, options?: AxiosRequestConfig) {
        return DatabasesApiFp(this.configuration).apiDatabasesDatabaseIdBackupschedulePost(databaseId, backupScheduleInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} databaseId 
     * @param {BackupScheduleInput} [backupScheduleInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DatabasesApi
     */
    public apiDatabasesDatabaseIdBackupschedulePut(databaseId: number, backupScheduleInput?: BackupScheduleInput, options?: AxiosRequestConfig) {
        return DatabasesApiFp(this.configuration).apiDatabasesDatabaseIdBackupschedulePut(databaseId, backupScheduleInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} databaseId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DatabasesApi
     */
    public apiDatabasesDatabaseIdBackuptypesGet(databaseId: number, options?: AxiosRequestConfig) {
        return DatabasesApiFp(this.configuration).apiDatabasesDatabaseIdBackuptypesGet(databaseId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} databaseId 
     * @param {CloneDatabaseInput} [cloneDatabaseInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DatabasesApi
     */
    public apiDatabasesDatabaseIdClonePost(databaseId: number, cloneDatabaseInput?: CloneDatabaseInput, options?: AxiosRequestConfig) {
        return DatabasesApiFp(this.configuration).apiDatabasesDatabaseIdClonePost(databaseId, cloneDatabaseInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} databaseId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DatabasesApi
     */
    public apiDatabasesDatabaseIdDelete(databaseId: number, options?: AxiosRequestConfig) {
        return DatabasesApiFp(this.configuration).apiDatabasesDatabaseIdDelete(databaseId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} databaseId 
     * @param {UpdateDatabaseInput} [updateDatabaseInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DatabasesApi
     */
    public apiDatabasesDatabaseIdPut(databaseId: number, updateDatabaseInput?: UpdateDatabaseInput, options?: AxiosRequestConfig) {
        return DatabasesApiFp(this.configuration).apiDatabasesDatabaseIdPut(databaseId, updateDatabaseInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} databaseId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DatabasesApi
     */
    public apiDatabasesDatabaseIdValidationscheduleGet(databaseId: number, options?: AxiosRequestConfig) {
        return DatabasesApiFp(this.configuration).apiDatabasesDatabaseIdValidationscheduleGet(databaseId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} databaseId 
     * @param {ValidationScheduleInput} [validationScheduleInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DatabasesApi
     */
    public apiDatabasesDatabaseIdValidationschedulePut(databaseId: number, validationScheduleInput?: ValidationScheduleInput, options?: AxiosRequestConfig) {
        return DatabasesApiFp(this.configuration).apiDatabasesDatabaseIdValidationschedulePut(databaseId, validationScheduleInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DatabasesApi
     */
    public apiDatabasesGet(options?: AxiosRequestConfig) {
        return DatabasesApiFp(this.configuration).apiDatabasesGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreateDatabaseInput} [createDatabaseInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DatabasesApi
     */
    public apiDatabasesPost(createDatabaseInput?: CreateDatabaseInput, options?: AxiosRequestConfig) {
        return DatabasesApiFp(this.configuration).apiDatabasesPost(createDatabaseInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DatabasesApi
     */
    public apiDatabasesTypesGet(options?: AxiosRequestConfig) {
        return DatabasesApiFp(this.configuration).apiDatabasesTypesGet(options).then((request) => request(this.axios, this.basePath));
    }
}


